/**
 * 20 mini interactive stories (branching). Kept short: 1 scene → 2 choices →
 * outcome + Carlos feedback. Great for onboarding.
 */

export const STORIES = [
  {
    id: 1,
    topic: "GREET",
    title: { es: "El primer saludo", en: "The first greeting" },
    scene: {
      es: "La familia González entra a la tienda. Están cansados del calor. Tú estás en el piso de sofás. ¿Qué haces?",
      en: "The González family walks in. They look tired from the heat. You're on the sofa floor. What do you do?",
    },
    choices: [
      { id: "a", label: { es: "Correr rápido a saludarlos y ofrecer agua", en: "Rush over to greet them and offer water" }, correct: true,
        outcome: { es: "¡Genial! Cortesía + calor humano = confianza inmediata.", en: "Great! Courtesy + human warmth = instant trust." } },
      { id: "b", label: { es: "Dejar que caminen para no incomodarlos", en: "Let them walk so you don't bother them" }, correct: false,
        outcome: { es: "Se sintieron ignorados y se fueron. El saludo se hace en los primeros 30s.", en: "They felt ignored and left. The greeting happens in the first 30 seconds." } },
    ],
  },
  {
    id: 2,
    topic: "DISCOVER",
    title: { es: "¿Sofá para quién?", en: "Sofa for whom?" },
    scene: { es: "La señora dice 'busco un sofá'. Es la única info que tienes.", en: "The lady says 'I'm looking for a sofa'. That's all you know." },
    choices: [
      { id: "a", label: { es: "Mostrar el más popular", en: "Show the top-seller" }, correct: false,
        outcome: { es: "No sabes si es para 2 o 6 personas. Primero descubre.", en: "You don't know if it's for 2 or 6 people. Discover first." } },
      { id: "b", label: { es: "Preguntar cuántas personas y qué actividades hacen", en: "Ask how many people and what activities they do" }, correct: true,
        outcome: { es: "¡Perfecto! Ahora puedes recomendar con confianza.", en: "Perfect! Now you can recommend with confidence." } },
    ],
  },
  {
    id: 3,
    topic: "F.A.B.",
    title: { es: "Vendiendo un colchón", en: "Selling a mattress" },
    scene: { es: "Un cliente pregunta '¿por qué este colchón es tan caro?'", en: "A customer asks 'why is this mattress so expensive?'" },
    choices: [
      { id: "a", label: { es: "Es el más nuevo y tiene 12 capas", en: "It's the newest with 12 layers" }, correct: false,
        outcome: { es: "Eso es Feature. Suma Advantage y Benefit para vender.", en: "That's just Feature. Add Advantage + Benefit to sell." } },
      { id: "b", label: { es: "Tiene 12 capas (F), lo que abraza tu columna (A), y descansarás profundo cada noche (B)", en: "12 layers (F), which hug your spine (A), so you sleep deeply every night (B)" }, correct: true,
        outcome: { es: "¡Bingo! F+A+B en una sola frase, imposible resistirse.", en: "Bingo! F+A+B in one sentence — irresistible." } },
    ],
  },
  {
    id: 4,
    topic: "CLOSE",
    title: { es: "El cliente duda", en: "The customer hesitates" },
    scene: { es: "Después de 40 minutos, el cliente dice 'déjame pensarlo'.", en: "After 40 minutes the customer says 'let me think about it'." },
    choices: [
      { id: "a", label: { es: "'Entiendo, ¿lo prefiere gris o beige?'", en: "'Understood. Do you prefer gray or beige?'" }, correct: true,
        outcome: { es: "Cierre alternativo. Muy pro.", en: "Alternative close. Very pro." } },
      { id: "b", label: { es: "'Pues piénselo'", en: "'Well, think about it'" }, correct: false,
        outcome: { es: "Perdiste la venta. Un buen cierre ofrece opciones, no despide al cliente.", en: "You lost the sale. A good close offers options, not a goodbye." } },
    ],
  },
  {
    id: 5,
    topic: "COMPLAINTS",
    title: { es: "Entrega tarde", en: "Late delivery" },
    scene: { es: "El cliente llega furioso porque su cama llegó un día tarde.", en: "The customer arrives furious — their bed came a day late." },
    choices: [
      { id: "a", label: { es: "Decir que es problema del proveedor", en: "Say it's the supplier's problem" }, correct: false,
        outcome: { es: "El cliente compró en Canales, no con el proveedor. Nosotros asumimos.", en: "The customer bought at Canales, not the supplier. We own it." } },
      { id: "b", label: { es: "Escuchar, disculparte y ofrecer envío gratis en su próxima compra", en: "Listen, apologize and offer free delivery on next purchase" }, correct: true,
        outcome: { es: "¡Bien! Convertiste una queja en fidelidad.", en: "Great! You turned a complaint into loyalty." } },
    ],
  },
  {
    id: 6,
    topic: "FINANCING",
    title: { es: "No alcanza para pagar hoy", en: "Can't pay in full today" },
    scene: { es: "El cliente ama el sofá pero solo trae $200.", en: "The customer loves the sofa but only has $200." },
    choices: [
      { id: "a", label: { es: "Explicar Synchrony: paga en cuotas, aprobación en 2 min", en: "Explain Synchrony: pay in installments, 2-min approval" }, correct: true,
        outcome: { es: "Financiamiento = puente al 'sí'.", en: "Financing = bridge to 'yes'." } },
      { id: "b", label: { es: "Decirle que vuelva cuando tenga todo el dinero", en: "Tell him to come back when he has all the money" }, correct: false,
        outcome: { es: "No va a volver. Otra tienda le va a ofrecer financiamiento primero.", en: "He won't be back. Another store will offer financing first." } },
    ],
  },
  {
    id: 7,
    topic: "FOLLOW-UP",
    title: { es: "24h después", en: "24h later" },
    scene: { es: "Un día después de entregar la sala, ¿qué haces?", en: "One day after delivering the living room set, what do you do?" },
    choices: [
      { id: "a", label: { es: "Llamas y preguntas cómo está disfrutando", en: "Call to ask how they're enjoying it" }, correct: true,
        outcome: { es: "¡Ese follow-up abre la puerta a referidos!", en: "That follow-up unlocks referrals!" } },
      { id: "b", label: { es: "Nada, ya cerraste la venta", en: "Nothing, the sale is closed" }, correct: false,
        outcome: { es: "Pierdes referidos y ventas futuras.", en: "You lose referrals and future sales." } },
    ],
  },
  {
    id: 8,
    topic: "COMMUNICATION",
    title: { es: "El cliente no entiende", en: "The customer doesn't get it" },
    scene: { es: "Estás usando palabras técnicas y el cliente pone cara confundida.", en: "You're using tech terms and the customer looks confused." },
    choices: [
      { id: "a", label: { es: "Repites más fuerte y más rápido", en: "Repeat louder and faster" }, correct: false,
        outcome: { es: "Volumen no es claridad. Simplifica.", en: "Volume isn't clarity. Simplify." } },
      { id: "b", label: { es: "Simplificas: usas ejemplos y dibujas en un papel", en: "Simplify: use examples and draw on paper" }, correct: true,
        outcome: { es: "¡Comunicaste de verdad!", en: "Now that's real communication!" } },
    ],
  },
  {
    id: 9,
    topic: "PREP",
    title: { es: "Antes de abrir", en: "Before opening" },
    scene: { es: "Faltan 30 min para abrir la tienda.", en: "30 min before opening." },
    choices: [
      { id: "a", label: { es: "Revisas precios, promos y limpieza del piso", en: "Review prices, promos and floor cleanliness" }, correct: true,
        outcome: { es: "Un vendedor preparado vende el doble.", en: "A prepared seller sells twice as much." } },
      { id: "b", label: { es: "Revisas redes sociales", en: "Scroll social media" }, correct: false,
        outcome: { es: "Cuando llegue el primer cliente vas a ir improvisando y perdiendo ventas.", en: "The first customer arrives and you're improvising, losing sales." } },
    ],
  },
  {
    id: 10,
    topic: "COURTESY",
    title: { es: "Sillón cómodo, café caliente", en: "Comfy chair, hot coffee" },
    scene: { es: "El cliente lleva 1 hora eligiendo.", en: "The customer has been choosing for 1 hour." },
    choices: [
      { id: "a", label: { es: "Ofreces agua o café y una silla cómoda", en: "Offer water/coffee and a comfy chair" }, correct: true,
        outcome: { es: "¡Cliente cómodo compra más!", en: "Comfortable customer buys more!" } },
      { id: "b", label: { es: "No haces nada, ya tienes hambre", en: "Do nothing, you're hungry yourself" }, correct: false,
        outcome: { es: "Se cansa y se va sin comprar.", en: "They get tired and leave without buying." } },
    ],
  },
  {
    id: 11,
    topic: "OBJECTION",
    title: { es: "'Está muy caro'", en: "'It's too expensive'" },
    scene: { es: "El cliente ve el precio y dice 'está muy caro'.", en: "The customer sees the price and says 'too expensive'." },
    choices: [
      { id: "a", label: { es: "'Sí, es lo que hay'", en: "'That's what we have'" }, correct: false,
        outcome: { es: "Perdiste la conversación.", en: "You lost the conversation." } },
      { id: "b", label: { es: "'Entiendo. ¿Comparado con qué?' y muestras valor + financiamiento", en: "'I understand. Compared to what?' — then show value + financing" }, correct: true,
        outcome: { es: "Convertiste una objeción en oportunidad.", en: "You turned an objection into opportunity." } },
    ],
  },
  {
    id: 12,
    topic: "SUGGESTIONS",
    title: { es: "Idea del cliente", en: "Customer idea" },
    scene: { es: "Una clienta sugiere más colores de almohadas.", en: "A customer suggests more pillow colors." },
    choices: [
      { id: "a", label: { es: "Le agradeces, anotas y le prometes seguimiento", en: "Thank her, write it down, promise follow-up" }, correct: true,
        outcome: { es: "Regla de las sugerencias: 6 pasos aplicados.", en: "Suggestions rule: 6 steps applied." } },
      { id: "b", label: { es: "Le dices que no es tu área", en: "Say it's not your area" }, correct: false,
        outcome: { es: "Pierdes una idea valiosa y un cliente.", en: "You lose a valuable idea and a customer." } },
    ],
  },
  {
    id: 13,
    topic: "DEMONSTRATE",
    title: { es: "Colchón de lujo", en: "Luxury mattress" },
    scene: { es: "Cliente parado frente a un colchón caro, dudando.", en: "Customer stands in front of an expensive mattress, hesitating." },
    choices: [
      { id: "a", label: { es: "Le explicas las capas mientras él mira", en: "Explain the layers while he watches" }, correct: false,
        outcome: { es: "Habla sin sentir = no vende.", en: "Talking without feeling = no sale." } },
      { id: "b", label: { es: "Le pides que se acueste y cierre los ojos por 30 segundos", en: "Ask him to lie down and close his eyes for 30 seconds" }, correct: true,
        outcome: { es: "Sentir = comprar.", en: "Feeling = buying." } },
    ],
  },
  {
    id: 14,
    topic: "GREET",
    title: { es: "Cliente digital", en: "Digital customer" },
    scene: { es: "Un cliente llega buscando 'el sofá del Instagram'.", en: "A customer arrives looking for 'the Instagram sofa'." },
    choices: [
      { id: "a", label: { es: "Sonríes y le pides ver la foto para acompañarlo", en: "Smile and ask to see the photo to help him" }, correct: true,
        outcome: { es: "Empatía + curiosidad = conexión.", en: "Empathy + curiosity = connection." } },
      { id: "b", label: { es: "Le dices 'no tenemos catálogo digital'", en: "Say 'we don't have a digital catalog'" }, correct: false,
        outcome: { es: "Cliente frustrado y sin venta.", en: "Frustrated customer and no sale." } },
    ],
  },
  {
    id: 15,
    topic: "CLOSE",
    title: { es: "Última oferta", en: "Last chance offer" },
    scene: { es: "La promo termina hoy y el cliente sigue dudando.", en: "The promo ends today and the customer is still hesitating." },
    choices: [
      { id: "a", label: { es: "Explicas con calma la promo y das opciones de entrega", en: "Calmly explain the promo and offer delivery options" }, correct: true,
        outcome: { es: "Urgencia real + opciones = decisión.", en: "Real urgency + options = decision." } },
      { id: "b", label: { es: "Le presionas con miedo: '¡Se va a acabar!'", en: "Pressure with fear: 'It's going to run out!'" }, correct: false,
        outcome: { es: "Nunca vender con miedo. Se siente.", en: "Never sell with fear. It shows." } },
    ],
  },
  {
    id: 16,
    topic: "FOLLOW-UP",
    title: { es: "Cliente antiguo", en: "Old customer" },
    scene: { es: "Vendiste un sofá hace 2 años a esa familia.", en: "You sold a sofa to that family 2 years ago." },
    choices: [
      { id: "a", label: { es: "Le mandas un mensaje: 'Feliz aniversario del sofá'", en: "Send a message: 'Happy sofa anniversary!'" }, correct: true,
        outcome: { es: "Detalle inolvidable — regresa a comprar.", en: "Unforgettable touch — they come back to buy." } },
      { id: "b", label: { es: "No haces nada", en: "Do nothing" }, correct: false,
        outcome: { es: "Pierdes un cliente que estaba listo.", en: "You lose a customer who was ready." } },
    ],
  },
  {
    id: 17,
    topic: "COMPLAINTS",
    title: { es: "Producto dañado", en: "Damaged product" },
    scene: { es: "Cliente llama: llegó una silla con la pata rota.", en: "Customer calls: a chair arrived with a broken leg." },
    choices: [
      { id: "a", label: { es: "Le pides paciencia y le mandas otra silla mañana + disculpa", en: "Ask for patience, ship a new one tomorrow + apologize" }, correct: true,
        outcome: { es: "Solución rápida + empatía = fidelidad.", en: "Fast fix + empathy = loyalty." } },
      { id: "b", label: { es: "Le dices que espere 2 semanas al proveedor", en: "Tell them to wait 2 weeks for the supplier" }, correct: false,
        outcome: { es: "Cliente enojado, reseña negativa.", en: "Angry customer, negative review." } },
    ],
  },
  {
    id: 18,
    topic: "COMMUNICATION",
    title: { es: "Cliente adulto mayor", en: "Elder customer" },
    scene: { es: "Un señor mayor tiene dudas sobre las medidas.", en: "An elderly gentleman is unsure about measurements." },
    choices: [
      { id: "a", label: { es: "Le dibujas en una hoja y le explicas paso a paso", en: "Draw on paper, explain step by step" }, correct: true,
        outcome: { es: "Visual + paciencia = venta segura.", en: "Visual + patience = sure sale." } },
      { id: "b", label: { es: "Le sueltas términos técnicos", en: "Blast him with tech terms" }, correct: false,
        outcome: { es: "Se siente perdido y se va.", en: "He feels lost and leaves." } },
    ],
  },
  {
    id: 19,
    topic: "TEAMWORK",
    title: { es: "Cliente ocupado", en: "Busy customer" },
    scene: { es: "El cliente tiene prisa. Tú estás con otro. ¿Qué haces?", en: "The customer is in a rush. You're with someone else. What do you do?" },
    choices: [
      { id: "a", label: { es: "Pides ayuda a un compañero para no perderlo", en: "Ask a coworker for help so we don't lose him" }, correct: true,
        outcome: { es: "El equipo cierra ventas, no un solo héroe.", en: "The team closes sales, not lone heroes." } },
      { id: "b", label: { es: "Le pides que espere 30 min", en: "Ask him to wait 30 min" }, correct: false,
        outcome: { es: "Se fue. No volverá.", en: "He left. He won't be back." } },
    ],
  },
  {
    id: 20,
    topic: "MINDSET",
    title: { es: "Mala mañana", en: "Bad morning" },
    scene: { es: "Tuviste una mala mañana. Llega tu primer cliente.", en: "You had a rough morning. First customer walks in." },
    choices: [
      { id: "a", label: { es: "Respiras, sonríes y das lo mejor", en: "Breathe, smile, give your best" }, correct: true,
        outcome: { es: "Mindset = ventas. Tu energía se contagia.", en: "Mindset = sales. Your energy is contagious." } },
      { id: "b", label: { es: "Lo atiendes con cara larga", en: "Serve them with a long face" }, correct: false,
        outcome: { es: "El cliente lo siente y no compra.", en: "The customer feels it and won't buy." } },
    ],
  },
];
